var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nextStep)?_c('svg-icon',{staticClass:"mobile-ar-step-icon",attrs:{"original":"","name":("navigation/" + (_vm.nextStep.direction) + "-black")}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }